import { globalStyleObj } from "@/app/assets/styles";
import React from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css"; // Import styles
import { LabelText } from "..";
import { editorOptions } from "@/app/assets/data/sun-editor-setting";

const CommonSunTextEditor = ({
  theme = "light",
  value = "",
  labelText = "",
  filedId = "",
  fieldName = "",
  fieldStatus = false,
  onTextEditorChange = () => {},
  isItemDetailsExist = false,
  extraClass = "",
  inputContainerMaxWidth = "max-w-[800px]",
  textEditorHeight = "300px",
}) => {
  return (
    <div
      className={`${globalStyleObj.commonInputContainerClass} ${extraClass}`}
    >
      <LabelText
        text={labelText}
        htmlForId={`${isItemDetailsExist ? `update-${filedId}` : `${filedId}`}`}
        star={fieldStatus}
        translateField={isItemDetailsExist}
      />

      <div
        className={`w-full ${inputContainerMaxWidth} rounded-sm border border-[#000]/20 dark:border-[#fff]/10`}
      >
        <SunEditor
          height={textEditorHeight}
          setDefaultStyle={
            theme === "dark"
              ? "background-color: #22262A; color: #ced4da; border: none; outline: none; box-shadow: none;"
              : "background-color: #ffffff; color: #495057; border: none; outline: none; box-shadow: none;"
          }
          name={fieldName}
          setOptions={{ ...editorOptions }}
          setContents={value}
          onChange={onTextEditorChange}
        />
      </div>
    </div>
  );
};

export default CommonSunTextEditor;
